export default "//yastatic.net/s3/distribution/pythia/frontend/_/6a235261be6f0984d37dc8611676dc39.png";